export const int32Max = 2147483647;
export const minRokStudiow = 1;
export const maxRokStudiow = 6;
export const minSrednia = 2;
export const maxSrednia = 5;
export const maxPageSize = 1000;
export const maxKwota = 9999999999;
export const maxYear = 2100;
export const minYear = 1900;
export const maxStringLength = 2147483647;
export const maxPhoneNumberLength = 15;
export const maxWartoscDyplomowania = 99999;
export const ASCIImaxLength = 255;
export const symbolMinLength = 3;
export const symbolMaxLength = 50;
export const symbolPattern = '\\S+';
export const minStringLength = 1;
export const maxOpisLength = 500;
export const stawkaRyczaltuMax = 100;
export const stawkaRyczaltuMin = 0;
export const minPunktyEctsProgramowStudiow = 1;
export const minPunktyEctsPrzedmiotow = 0;
export const maxAdnotacjeLength = 1000;
export const uwagiMaxLength = 1000;
export const maxKomentarzLength = 2000;
export const maxOswiadczenieLength = 4000;
export const reasonableMaxStringLength = 9999; // bo maxStringLength to w rzeczywistości za dużo
export const reasonableMaxInt = 999999999;
export const minKwota = 0;
export const minKwotaDodatnia = 0.01;
export const maxDecimal = 9999999999999.99;
export const minDecimal = -9999999999999.99;
export const kodKrajuMaxLength = 2;
export const maxKonfiguracjaStypendiow = 9999999999.99;
export const maxDateCurrent = new Date();
export const weekStartsOn: 0 | 1 | 2 | 3 | 4 | 5 | 6 = 1; // ISO 8601
